import { useQuery } from '@tanstack/react-query';
import { http } from '@lib/api';
import { queryKeys } from '@lib/queryKeys';
import type { components } from '@/types/api.generated';

export type AssignmentProgressWire = components['schemas']['DispatchAssignment'];

/**
 * Onfleet assignment progress of one shipping day (#2470 read endpoint).
 * Re-read every minute so the pane keeps up with taskAssigned webhooks.
 */
export function useAssignmentProgress(date: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.dispatch.assignment(date),
    queryFn: () => http.get<AssignmentProgressWire>(`/api/dispatch/assignment?date=${date}`),
    refetchInterval: 60_000,
    enabled: options?.enabled ?? true,
  });
}
